import { z } from 'zod';

/** Reviewed playbooks, not arbitrary model-generated AWS commands. Numbers match the launch scope. */
const entries = [
  [1, 'cloudtrail_logging', 'Enable CloudTrail logging', 'CloudTrail', 'review', 'cloudtrail.*(?:enabled|logging|trail exists)'],
  [2, 'cloudtrail_multi_region', 'Enable multi-Region CloudTrail', 'CloudTrail', 'low', 'cloudtrail.*multi.?region|multi.?region.*trail'],
  [
    3,
    'cloudtrail_validation',
    'Validate CloudTrail log integrity',
    'CloudTrail',
    'low',
    '(?:cloudtrail|log file).*integrity|log file validation',
  ],
  [4, 'cloudtrail_management', 'Log CloudTrail management events', 'CloudTrail', 'low', 'cloudtrail.*management|management event.*log'],
  [
    5,
    'cloudtrail_cloudwatch',
    'Connect CloudTrail to CloudWatch Logs',
    'CloudTrail',
    'review',
    'cloudtrail.*cloudwatch|cloudwatch.*cloudtrail',
  ],
  [6, 'config_recording', 'Enable AWS Config recording', 'Config', 'review', '(?:aws |amazon )?config.*record|configuration recorder'],
  [7, 'guardduty', 'Enable GuardDuty', 'GuardDuty', 'review', 'guardduty'],
  [8, 'securityhub', 'Enable Security Hub CSPM', 'Security Hub', 'review', 'security hub'],
  [9, 'access_analyzer', 'Enable IAM Access Analyzer', 'IAM', 'low', 'access analyzer'],
  [10, 'vpc_flow_logs', 'Enable approved VPC flow logs', 'VPC', 'review', 'vpc.*flow log|flow log.*vpc'],
  [
    11,
    'log_retention',
    'Meet CloudWatch log retention requirements',
    'CloudWatch',
    'low',
    '(?:cloudwatch|log group|aws log).*retention|retention.*cloudwatch',
  ],
  [12, 's3_logging', 'Enable approved S3 access logging', 'S3', 'review', 's3.*(?:access logging|access logs)|bucket.*access log'],
  [13, 's3_encryption', 'Enable default S3 encryption', 'S3', 'low', '(?:s3|bucket).*(?:encrypt|sse.s3)'],
  [14, 's3_versioning', 'Enable required S3 versioning', 'S3', 'review', '(?:s3|bucket).*versioning'],
  [15, 'ebs_encryption', 'Encrypt new EBS volumes by default', 'EC2', 'low', 'ebs.*(?:encrypt|default)|default.*ebs'],
  [16, 'kms_rotation', 'Enable eligible KMS key rotation', 'KMS', 'low', '(?:kms|key).*rotation'],
  [17, 'alarm_root', 'Alert on root account usage', 'CloudWatch', 'low', '(?:alarm|alert|metric filter).*root|root.*(?:alarm|alert)'],
  [
    18,
    'alarm_unauthorized',
    'Alert on unauthorized API calls',
    'CloudWatch',
    'low',
    '(?:alarm|alert).*unauthori[sz]ed|unauthori[sz]ed.*(?:alarm|alert)',
  ],
  [
    19,
    'alarm_failed_login',
    'Alert on failed console logins',
    'CloudWatch',
    'low',
    '(?:alarm|alert).*failed.*login|failed.*login.*(?:alarm|alert)',
  ],
  [
    20,
    'alarm_no_mfa',
    'Alert on console logins without MFA',
    'CloudWatch',
    'low',
    '(?:alarm|alert).*(?:without mfa|no mfa)|without mfa.*(?:alarm|alert)',
  ],
  [21, 'alarm_iam', 'Alert on IAM policy changes', 'CloudWatch', 'low', 'iam.*polic.*(?:alarm|alert)|(?:alarm|alert).*iam.*polic'],
  [
    22,
    'alarm_cloudtrail',
    'Alert on CloudTrail changes',
    'CloudWatch',
    'low',
    '(?:alarm|alert).*cloudtrail|cloudtrail.*chang.*(?:alarm|alert)',
  ],
  [23, 'alarm_kms', 'Alert on KMS key changes', 'CloudWatch', 'low', '(?:alarm|alert).*kms|kms.*chang.*(?:alarm|alert)'],
  [
    24,
    'alarm_s3_policy',
    'Alert on S3 bucket policy changes',
    'CloudWatch',
    'low',
    '(?:alarm|alert).*s3.*polic|bucket polic.*(?:alarm|alert)',
  ],
  [25, 'alarm_config', 'Alert on AWS Config changes', 'CloudWatch', 'low', '(?:alarm|alert).*config.*chang|config.*chang.*(?:alarm|alert)'],
  [
    26,
    'alarm_security_group',
    'Alert on security group changes',
    'CloudWatch',
    'low',
    '(?:alarm|alert).*security group|security group.*chang.*(?:alarm|alert)',
  ],
  [
    27,
    'alarm_nacl',
    'Alert on network ACL changes',
    'CloudWatch',
    'low',
    '(?:alarm|alert).*network acl|network acl.*chang.*(?:alarm|alert)',
  ],
  [28, 'alarm_vpc', 'Alert on VPC changes', 'CloudWatch', 'low', '(?:alarm|alert).*vpc.*chang|vpc.*chang.*(?:alarm|alert)'],
  [
    29,
    'alarm_route',
    'Alert on route table changes',
    'CloudWatch',
    'low',
    '(?:alarm|alert).*route table|route table.*chang.*(?:alarm|alert)',
  ],
  [30, 'sns_notifications', 'Connect security alarms to SNS', 'SNS', 'review', '(?:sns|alarm).*(?:notification|subscription)'],
  [31, 'alarm_ec2_cpu', 'Monitor EC2 CPU utilization', 'EC2', 'low', 'ec2.*cpu'],
  [32, 'alarm_rds_cpu', 'Monitor RDS CPU utilization', 'RDS', 'low', 'rds.*cpu'],
  [33, 'alarm_rds_storage', 'Monitor RDS free storage', 'RDS', 'low', 'rds.*(?:free storage|storage space)'],
  [34, 'alarm_rds_io', 'Monitor RDS read and write I/O', 'RDS', 'low', 'rds.*(?:iops|i/o|read.*write)'],
  [35, 'alarm_rds_memory', 'Monitor RDS freeable memory', 'RDS', 'low', 'rds.*(?:freeable memory|free memory)'],
  [36, 'alarm_sqs_age', 'Monitor SQS oldest-message age', 'SQS', 'low', 'sqs.*(?:oldest|message age)'],
  [37, 'alarm_dynamodb_capacity', 'Monitor DynamoDB capacity', 'DynamoDB', 'low', 'dynamodb.*(?:capacity|utilization)'],
  [38, 'alarm_alb_latency', 'Monitor ALB response latency', 'Load balancing', 'low', '(?:alb|load balanc).*(?:latency|response time)'],
  [39, 'alarm_alb_5xx', 'Monitor ALB HTTP 5XX errors', 'Load balancing', 'low', '(?:alb|load balanc).*5xx'],
  [40, 'alarm_alb_targets', 'Monitor ALB unhealthy targets', 'Load balancing', 'low', '(?:alb|load balanc).*unhealthy'],
  [41, 'alarm_lambda_errors', 'Monitor Lambda errors', 'Lambda', 'low', 'lambda.*error'],
  [42, 'backup_monitoring', 'Monitor AWS Backup jobs', 'Backup', 'low', '(?:aws |amazon )?backup.*(?:monitor|alarm)'],
  [43, 'backup_notifications', 'Notify on backup failures', 'Backup', 'review', 'backup.*(?:failure|failed).*notification'],
  [44, 'dynamodb_pitr', 'Enable required DynamoDB point-in-time recovery', 'DynamoDB', 'review', 'dynamodb.*(?:point.in.time|pitr)'],
  [45, 'inspector', 'Enable Inspector vulnerability scanning', 'Inspector', 'review', 'inspector'],
  [46, 'ecr_scanning', 'Enable ECR image scanning', 'ECR', 'review', '(?:ecr|container image).*scann'],
  [47, 'finding_mfa', 'Find IAM users without MFA', 'IAM', 'finding', '(?:iam|aws).*(?:missing mfa|without mfa|mfa enabled|multi.factor)'],
  [48, 'finding_unused_keys', 'Find unused IAM access keys', 'IAM', 'finding', '(?:iam|aws|access key).*(?:unused|inactive|last used)'],
  [49, 'finding_root', 'Find root account activity', 'IAM', 'finding', 'root.*(?:usage|activity|used|access key)'],
  [
    50,
    'finding_policies',
    'Find overly permissive IAM policies',
    'IAM',
    'finding',
    '(?:iam|aws).*(?:permissive|wildcard|least privilege|administrator access)',
  ],
] as const;
export const RUMI_CODE_CATALOG = entries.map(([number, id, title, service, risk, pattern]) => ({
  number,
  id,
  title,
  service,
  risk,
  pattern,
}));
export type RecipeId = (typeof entries)[number][1];
export const RecipeIdSchema = z.enum(entries.map((e) => e[1]) as [RecipeId, ...RecipeId[]]);
export const recipe = (id: RecipeId) => RUMI_CODE_CATALOG.find((r) => r.id === id)!;
export const matchAwsRecipes = (title: string, description: string): RecipeId[] => {
  const text = `${title}\n${description}`;
  if (
    !/\b(?:aws|amazon|cloudtrail|cloudwatch|guardduty|security hub|s3|ebs|kms|iam|vpc|rds|ec2|ecr|sqs|dynamodb|lambda|alb|inspector)\b/i.test(
      text,
    )
  )
    return [];
  return (
    RUMI_CODE_CATALOG.filter((r) => new RegExp(r.pattern, 'i').test(text))
      // Root MFA is not the IAM-user MFA playbook. Keep unsupported controls out of the queue.
      .filter((r) => r.id !== 'finding_mfa' || !/\broot\b/i.test(title))
      .sort((a, b) => Number(new RegExp(b.pattern, 'i').test(title)) - Number(new RegExp(a.pattern, 'i').test(title)))
      .map((r) => r.id)
  );
};

const text = z.string().min(1).max(500);
const arn = z
  .string()
  .regex(/^arn:aws:[a-z0-9-]+:[a-z0-9-]*:[0-9]*:.+$/)
  .max(2048);
export const RegionSchema = z.string().regex(/^(?:us|eu|ap|sa|ca|me|af|il|mx)-(?:[a-z]+-)?[a-z]+-\d$/);
export const RequirementSchema = z.object({
  value: z.number().finite().nonnegative(),
  source: z.enum(['provider', 'user']),
  rationale: z.string().min(1).max(1000),
});
export const RequirementsSchema = z.record(z.string().regex(/^[a-zA-Z][a-zA-Z0-9]{0,50}$/), RequirementSchema);
export type Requirements = z.infer<typeof RequirementsSchema>;
/** Only explicit test text is extracted. Framework labels never supply numeric defaults. */
export function extractRequirements(description: string): Requirements {
  const out: Requirements = {};
  for (const [key, regex] of [
    ['retentionDays', /(?:retain(?:ed)?|retention)[^.\n]{0,65}?(\d+)\s*days?\b/gi],
    ['unusedKeyDays', /(?:unused|inactive|not (?:been )?used)[^.\n]{0,65}?(\d+)\s*days?\b/gi],
    ['threshold', /\bthreshold\s*(?:of|is|:|=)?\s*(\d+(?:\.\d+)?)\b/gi],
    ['periodSeconds', /\bevaluation period\s*(?:of|is|:|=)?\s*(\d+)\s*seconds?\b/gi],
    ['evaluationPeriods', /\b(\d+)\s+consecutive evaluation periods?\b/gi],
    ['rotationDays', /(?:rotat(?:e|ed|ion))[^.\n]{0,65}?(\d+)\s*days?\b/gi],
  ] as const) {
    const matches = [...description.matchAll(regex)];
    const values = new Set(matches.map((m) => Number(m[1])));
    if (values.size === 1 && matches[0]) out[key] = { value: Number(matches[0][1]), source: 'provider', rationale: matches[0][0] };
  }
  return out;
}
export function requiredValues(id: RecipeId): { key: string; label: string }[] {
  if (id === 'log_retention') return [{ key: 'retentionDays', label: 'Minimum retention (days)' }];
  if (id === 'finding_unused_keys') return [{ key: 'unusedKeyDays', label: 'Unused key threshold (days)' }];
  if (id === 'kms_rotation') return [{ key: 'rotationDays', label: 'Maximum key rotation interval (days)' }];
  if (id.startsWith('alarm_') || id === 'backup_monitoring')
    return [
      {
        key: 'threshold',
        label:
          id.includes('cpu') || id.includes('capacity')
            ? 'Alarm threshold (%)'
            : id.includes('storage') || id.includes('memory')
              ? 'Alarm threshold (bytes)'
              : id.includes('latency') || id.includes('age')
                ? 'Alarm threshold (seconds)'
                : 'Alarm threshold (count / operations)',
      },
      { key: 'periodSeconds', label: 'Evaluation period (seconds)' },
      { key: 'evaluationPeriods', label: 'Consecutive evaluation periods' },
    ];
  return [];
}
export const SourceTestSchema = z.object({
  recordKey: z.string().min(1).max(1000),
  provider: z.enum(['vanta', 'drata']),
  testId: text,
  connectionId: z.string().uuid(),
  snapshotId: z.string().uuid(),
  title: text,
  description: z.string().max(20000),
  status: text,
  capturedAt: z.string().datetime(),
});
export const CodeTaskSchema = z.object({ source: SourceTestSchema, recipeIds: z.array(RecipeIdSchema), requirements: RequirementsSchema });
export type CodeTask = z.infer<typeof CodeTaskSchema>;
export type SourceTest = z.infer<typeof SourceTestSchema>;

export const RegionDestinationsSchema = z.object({
  trailBucket: text.optional(),
  trailName: z
    .string()
    .regex(/^[a-zA-Z0-9._-]{3,128}$/)
    .optional(),
  cloudWatchLogGroupArn: arn.optional(),
  cloudWatchRoleArn: arn.optional(),
  configRoleArn: arn.optional(),
  configBucket: text.optional(),
  flowLogGroupArn: arn.optional(),
  flowLogRoleArn: arn.optional(),
  snsTopicArn: arn.optional(),
  s3LogBucket: text.optional(),
});
export const AwsConnectionInputSchema = z.object({
  roleArn: z.string().regex(/^arn:aws:iam::\d{12}:role\/[A-Za-z0-9+=,.@_/-]+$/),
  regions: z.array(RegionSchema).min(1).max(30),
  allowedUserIds: z.array(z.string().uuid()).max(100),
  approvedResourceArns: z.array(arn).max(500),
  preauthorizedRecipeIds: z.array(RecipeIdSchema).max(50),
  destinations: z.record(RegionSchema, RegionDestinationsSchema),
  useAwsKnowledge: z.boolean(),
  revision: z.number().int().nonnegative(),
});
export const AwsConnectionSchema = AwsConnectionInputSchema.omit({ roleArn: true }).extend({
  regions: z.array(RegionSchema).max(30),
  roleArn: z.string().nullable(),
  externalId: text,
  awsAccountId: z.string().nullable(),
  verifiedAt: z.string().datetime().nullable(),
  configuredBy: z.string().uuid(),
});
export type AwsConnection = z.infer<typeof AwsConnectionSchema>;
export type AwsConnectionInput = z.infer<typeof AwsConnectionInputSchema>;
export const CodeStartSchema = z.object({
  source: SourceTestSchema,
  recipeId: RecipeIdSchema,
  requirements: RequirementsSchema,
  userNote: z.string().max(4000).default(''),
  resourceArns: z.array(arn).max(100),
  regions: z.array(RegionSchema).min(1).max(30),
  executionMode: z.enum(['preauthorized', 'approval']),
  requestId: z.string().uuid(),
});
export type CodeStart = z.infer<typeof CodeStartSchema>;
export const AwsCallSchema = z.object({ service: text, operation: text, region: RegionSchema, input: z.record(z.string(), z.json()) });
export type AwsCall = z.infer<typeof AwsCallSchema>;
export const CodeChangeSchema = z.object({
  id: z.string(),
  resourceArn: z.string(),
  region: RegionSchema,
  summary: text,
  risk: z.enum(['low', 'review']),
  before: z.json(),
  desired: z.json(),
  read: AwsCallSchema,
  writes: z.array(AwsCallSchema).max(5),
  verification: z.enum(['cloudtrail_logging', 'subset', 'path', 'finding']),
  checks: z.array(z.object({ path: z.string(), equals: z.json() })).default([]),
});
export type CodeChange = z.infer<typeof CodeChangeSchema>;
export const CodePlanSchema = z.object({
  changes: z.array(CodeChangeSchema).max(100),
  findings: z.array(z.object({ resourceArn: text, message: z.string().max(5000) })).max(1000),
  observations: z.array(z.object({ resourceArn: text, region: RegionSchema, configuration: z.json() })).max(1000),
  blockers: z.array(text),
  digest: z.string(),
  connectionRevision: z.number().int(),
  createdAt: z.string().datetime(),
});
export type CodePlan = z.infer<typeof CodePlanSchema>;
export const CodeRunStateSchema = z.enum([
  'queued',
  'discovering',
  'awaiting_approval',
  'ready',
  'executing',
  'verifying',
  'succeeded',
  'findings',
  'blocked',
  'failed',
  'cancelled',
  'interrupted',
]);
export const CodeEventSchema = z.object({
  sequence: z.number().int(),
  at: z.string().datetime(),
  type: text,
  message: z.string().max(5000),
  resourceArn: z.string().nullable(),
  data: z.json(),
  hash: text,
  previousHash: z.string().nullable(),
});
export type CodeEvent = z.infer<typeof CodeEventSchema>;
export const CodeRunSchema = z.object({
  id: z.string().uuid(),
  accountId: z.string().uuid(),
  userId: z.string().uuid(),
  state: CodeRunStateSchema,
  input: CodeStartSchema,
  plan: CodePlanSchema.nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  approvedBy: z.string().uuid().nullable(),
  approvedAt: z.string().datetime().nullable(),
  cancelRequested: z.boolean(),
  summary: z.string(),
  providerStatus: z.string(),
});
export type CodeRun = z.infer<typeof CodeRunSchema>;
export const CodeDetailSchema = z.object({ run: CodeRunSchema, events: z.array(CodeEventSchema) });
export const CodeWorkspaceSchema = z.object({
  connection: AwsConnectionSchema.nullable(),
  runs: z.array(CodeRunSchema),
  executionAvailable: z.boolean(),
  setupMessage: z.string().nullable(),
});
